import { createAction, props } from '@ngrx/store';
import { INgrxRoute } from '@medlogic/shared/shared-interfaces';

export const go = createAction('[router] Go', props<{ to: INgrxRoute }>());
export const back = createAction('[router] BACK');
export const forward = createAction('[router] FORWARD');
